import { createReducer } from 'redux-act';

import {
  SCHEDULING_FETCH_DATA_INIT,
  SCHEDULING_FETCH_DATA_SUCCESS,
  SCHEDULING_FETCH_DATA_FAIL,
  SCHEDULING_DELETE_SCHEDULING_INIT,
  SCHEDULING_DELETE_SCHEDULING_SUCCESS,
  SCHEDULING_DELETE_SCHEDULING_FAIL,
  SCHEDULING_CLEAR_DATA,
  SCHEDULING_CREATE_SCHEDULING_INIT,
  SCHEDULING_CREATE_SCHEDULING_SUCCESS,
  SCHEDULING_CREATE_SCHEDULING_FAIL,
  SCHEDULING_MODIFY_SCHEDULING_INIT,
  SCHEDULING_MODIFY_SCHEDULING_SUCCESS,
  SCHEDULING_MODIFY_SCHEDULING_FAIL,
  SCHEDULING_CLEAN_UP,
  SCHEDULING_CLEAR_DATA_LOGOUT,
  SET_MEDIA_SCHEDULING,
} from 'state/actions/scheduling';

const initialState = {
  list: [],
  scheduling: {
    _id: '',
    name: '',
    description: '',
  },
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
};

export const schedulingReducer = createReducer(
  {
    [SCHEDULING_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true,
    }),
    [SCHEDULING_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.list || [],
      scheduling: payload.scheduling || initialState.scheduling,
      loading: false,
      error: null,
    }),
    [SCHEDULING_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCHEDULING_DELETE_SCHEDULING_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SCHEDULING_DELETE_SCHEDULING_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((elem) => elem._id !== payload.id),
      loading: false,
      error: null,
      deleted: true,
    }),
    [SCHEDULING_DELETE_SCHEDULING_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCHEDULING_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [SCHEDULING_CREATE_SCHEDULING_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SCHEDULING_CREATE_SCHEDULING_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [SCHEDULING_CREATE_SCHEDULING_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCHEDULING_MODIFY_SCHEDULING_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SCHEDULING_MODIFY_SCHEDULING_SUCCESS]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [SCHEDULING_MODIFY_SCHEDULING_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCHEDULING_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false,
      updated: false,
    }),
    [SCHEDULING_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
    [SET_MEDIA_SCHEDULING]: (state, payload) => ({
      ...state,
      scheduling: payload.data,
    }),
  },
  initialState
);
